export default function AdminDashboard() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Admin Dashboard</h1>
      <div className="card p-6">
        <p className="text-gray-500">Admin panel coming soon...</p>
      </div>
    </div>
  );
}
